export default __webpack_public_path__ + "static/media/player-and-qa-component.2822156b.png";